import { useMarketDetail } from '../queries/useMarketDetail';
import { useEffect, useState } from 'react';
import { bridge, isNotNil, useAsyncEffect } from 'shared/src/utils';
import { useAppLifeCycle } from 'shared/src/hooks';

export const useIsFavoriteMarket = (marketId: number) => {
  const { lifeCycle } = useAppLifeCycle();

  const { data: marketDetail } = useMarketDetail(marketId);

  const [isFavoriteMarket, setIsFavoriteMarket] = useState(
    marketDetail.market.favorite !== null,
  );

  useAsyncEffect(async () => {
    if (lifeCycle === 'viewWillAppear') {
      const localMarketLike = await bridge.getLocalMarketFavorite();

      if (isNotNil(localMarketLike)) {
        const localFavorite = localMarketLike[marketId];
        if (isNotNil(localFavorite)) {
          setIsFavoriteMarket(localFavorite);
        }
      }
    }
  });

  useEffect(() => {
    if (marketDetail) {
      setIsFavoriteMarket(marketDetail.market.favorite !== null);
    }
  }, [marketDetail]);

  return {
    isFavoriteMarket,
  };
};
